// removed by extract-text-webpack-plugin
module.exports = {"component":"_7FHUo-QBFO8P0WFy2cycR","messagePlaceholder":"_23Ne3-WAjVRbfA4Icuvxvo","message":"_1Sl1QTiJ9rS2APQZnOdUWr"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Pages/Health/HealthRecordListContainer/HealthRecordListContainer.css
// module id = 1267
// module chunks = 0